import { isProfileComplete, PROFILE_INCOMPLETE_CODE } from '~/utils/profileOptions'

// 投票前的個人資料關卡：暱稱、性別、出生年、信箱、居住地區沒填齊就導去會員中心補，
// 補完再回到原本那一頁（member.vue 認 complete 與 redirect 兩個參數）。
// 投票頁與步道詳情兩處的投票鈕共用這一份
export function useProfileGate() {
  const route = useRoute()
  const { user, fetchUser } = useAuth()

  // redirect 是補完之後要回去的站內路徑，不給就回到當下這一頁
  function goCompleteProfile(redirect = route.fullPath) {
    return navigateTo({ path: '/member', query: { complete: '1', redirect } })
  }

  /**
   * 個人資料填齊了沒；沒填齊會直接導去會員中心並回 false
   * @param {string} [redirect] 補完之後要回去的站內路徑
   * 參與者資料只有登入或進會員中心時才會取回，其他頁面可能還是空的，缺了就先問一次。
   * 問不到就放行，交給後端的投票介面做最後一道檢查（會回 428）
   */
  async function ensureProfileComplete(redirect) {
    let current = user.value
    if (!current) {
      try {
        current = await fetchUser()
      } catch {
        return true
      }
    }
    if (isProfileComplete(current)) return true
    await goCompleteProfile(redirect)
    return false
  }

  // 投票介面回 428 時呼叫端用它判斷要不要改走導頁
  const isProfileIncomplete = (err) => err?.code === PROFILE_INCOMPLETE_CODE

  return { ensureProfileComplete, goCompleteProfile, isProfileIncomplete }
}
